export const banks = [
  {
    link: 'khanbank://q?qPay_QRcode=',
    name: 'Khan Bank',
    image: '/images/bank/khanbank.webp',
  },
  {
    link: 'tdbbank://q?qPay_QRcode=',
    name: 'TDB Online',
    image: '/images/bank/tdb.webp',
  },
  {
    link: 'socialpay-payment://q?qPay_QRcode=',
    name: 'SocialPay',
    image: '/images/bank/socialpay.webp',
  },
  {
    link: 'statebankmongolia://q?qPay_QRcode=',
    name: 'State bank 3.0',
    image: '/images/bank/statebank.webp',
  },
  {
    link: 'xacbank://q?qPay_QRcode=',
    name: 'XacBank',
    image: '/images/bank/xacbank.webp',
  },
  {
    link: 'capitronbank://q?qPay_QRcode=',
    name: 'Capitron Bank',
    image: '/images/bank/capitron-bank.webp',
  },
  {
    link: 'bogdbank://q?qPay_QRcode=',
    name: 'Bogd Bank',
    image: '/images/bank/bogd-bank.webp',
  },
  {
    link: 'nibank://q?qPay_QRcode=',
    name: 'NIBank',
    image: '/images/bank/nibank.webp',
  },
  {
    link: 'most://q?qPay_QRcode=',
    name: 'MostMoney',
    image: '/images/bank/most-money.webp',
  },
  {
    link: 'transbank://q?qPay_QRcode=',
    name: 'Transbank',
    image: '/images/bank/transbank.webp',
  },
  {
    link: 'mbank://q?qPay_QRcode=',
    name: 'M bank',
    image: '/images/bank/mbank.webp',
  },
  {
    link: 'arig://q?qPay_QRcode=',
    name: 'Arig Bank',
    image: '/images/bank/arig-bank.webp',
  },
  {
    link: 'ckbank://q?qPay_QRcode=',
    name: 'Chinggis khaan',
    image: '/images/bank/ckbank.webp',
  },
  {
    link: 'monpay://q?qPay_QRcode=',
    name: 'Monpay',
    image: '/images/bank/monpay.webp',
  },
  {
    link: 'toki://q?qPay_QRcode=',
    name: 'Toki',
    image: '/images/bank/toki.webp',
  },
  {
    link: 'ard://q?qPay_QRcode=',
    name: 'Ard App',
    image: '/images/bank/ard.webp',
  },
  {
    link: 'hipay://q?qPay_QRcode=',
    name: 'Hipay',
    image: '/images/bank/hipay.webp',
  },
  {
    link: 'tdbwallet://q?qPay_QRcode=',
    name: 'Happy Pay',
    image: '/images/bank/tdbwallet.webp',
  },
  {
    link: 'qpaywallet://q?qPay_QRcode=',
    name: 'QPAY wallet',
    image: '/images/bank/qpay-wallet.webp',
  },
];
